/* eslint-disable react/jsx-props-no-spreading */
import React, { Suspense, lazy } from 'react';

const HowItWorksAccordion = lazy(() => import('./index'));

export const HowItWorksAccordionSuspense = (props) => {
  if (typeof window === 'undefined') return <div />;

  return (
    <Suspense fallback={<div />}>
      <HowItWorksAccordion {...props} />
    </Suspense>
  );
};
